import { useMemo, useCallback, useEffect } from "react";
import moment from "moment-timezone";
import { filterKeyMapping, TOOL_PANELS } from "../Constants/constants";
import { convertStrToObjColumns, convertToCameCase, onlyUnique } from "./equipmentService";
import DATA_MODEL_TABLE from "../../../utils/constants/dataModelTable";
import GridIcons from "../icons/GridIcons";
import { agGridAutoGroupfieldName, DEFAULT_FILTER, listOfFieldsSortable } from "../../../constants";
import { uniq, filter } from "lodash";
import {
  onCreatefilter,
  onCreateSelectColumn, onDeleteSaveConfigurations,
  onUpdateFilter,
  onUpdateSelectColumn
} from "../../../features/equipment-list/EquipmentHelper";
import {
  CREATE_USER_DISPLAY_COLUMN,
  CREATE_USER_FILTER,
  DELETE_USER_DISPLAY_COLUMN,
  DELETE_USER_FILTER,
  UPDATE_DIGITAL_LAB_BOOKING_USER_PROFILE_PERSONAL_FIELDS, UPDATE_USER_DISPLAY_COLUMN, UPDATE_USER_FILTER
} from "../../../gql/bookingapi";
import { useHistory } from "react-router-dom";
import { cloneDeep } from "lodash";
import { GET_BOOKING_ENTRIES_BY_BOOKING_ID } from "../../../gql/bookingapi";
import { singleEventSkeleton } from "../../../constants";
import { getAllData } from "../../../utils/helpers/fetching";
import { prepareBookingForDuplication } from "../../../utils/helpers/data";

export const useBooking = ({
  filterState,
  displayPreset,
  defaultShowColumns,
  gridRef,
  onAgGridColumnApply,
  savedFilter,
  isFilterDataReady,
  updateCurrentFilter,
  loadFilterData,
  user,
  gridApi,
  searchQuery,
  client,
  localUserFilters,
  setUserFilters,
  setLastFavFilter,
  setUserDisplayColumnMaster,
  setLastDisplayColumns,
  userFilters,
  userDisplayColumnMaster,
  setSelectedEquipment,
  selectedEquipment,
  setDisplayPreset,
  setSavedFilter,
  loadPendingReservations,
  dispatchAction,
  bookingDispatchAction
}) => {
  const history = useHistory();

  const currentFilterChip = useMemo(() => ({
    chipName: filterState?.currentFilter?.filterName || "Default",
    filterDefinition: filterState?.currentFilter?.filterDefinition || {},
  }), [filterState?.currentFilter]);

  const onSave = async ({
    currentState,
    chipName = "",
    type = "update",
    isAgGridObj = false,
    pannel = "",
    isSaveConfigUpdated = false,
    updateRedux = true,
  }) => {
    let result = null;
    if (pannel === TOOL_PANELS.filters) {
      let obj = {};
      if (isAgGridObj) {
        for (const key in DEFAULT_FILTER.filterDefinition) {
          if (currentState[filterKeyMapping[key] || key] === undefined) {
            obj[key] = DEFAULT_FILTER.filterDefinition[key];
          } else if (currentState[filterKeyMapping[key] || key]?.filterType === "set") {
            let values = currentState[filterKeyMapping[key] || key]?.values;
            if (
              filterKeyMapping[key] === DATA_MODEL_TABLE.equipmentModel?.key ||
              key === DATA_MODEL_TABLE.equipmentModel?.key
            ) {
              if (Object.keys(currentState)?.includes(agGridAutoGroupfieldName)) {
                values = uniq([...values, ...currentState[agGridAutoGroupfieldName]?.values]);
              }
            }
            obj[key] = values;
          } else {
            obj[key] = currentState[filterKeyMapping[key] || key];
          }
        }
      } else {
        obj = { ...currentState };
      }

      const lastSavedFilter = {
        filterDefinition: obj,
        filterName: chipName,
      };

      if (type === "create") {
        lastSavedFilter.userID = user?.id;
        lastSavedFilter.chipName = chipName;
        result = await onCreatefilter({
          id: user?.id,
          email: user?.email,
          name: user?.name,
          site: user?.site,
          userFilters: localUserFilters.current,
          lastFavFilter: lastSavedFilter,
          client,
          query: CREATE_USER_FILTER,
          userProfileQuery: UPDATE_DIGITAL_LAB_BOOKING_USER_PROFILE_PERSONAL_FIELDS,
          updateUserFilters: setUserFilters,
          updateLastFavFilter: setLastFavFilter,
        });
      } else {
        let id = user?.id;
        const isBookingAdmin = user?.roles?.some((role) => role === "BookingAdmin");
        let isAdminModifyingOtherUserFilter = false;
        if (isBookingAdmin) {
          const filterToEdit = userFilters.find((f) => f.filterName === chipName);
          if (filterToEdit && filterToEdit.userID !== user?.id) {
            isAdminModifyingOtherUserFilter = true;
          }
          id = filterToEdit?.userID || user?.id;
        }
        result = await onUpdateFilter({
          lastFavFilter: lastSavedFilter,
          isSaveConfigUpdated,
          updateRedux,
          id,
          email: user?.email,
          client,
          query: UPDATE_USER_FILTER,
          userProfileQuery: UPDATE_DIGITAL_LAB_BOOKING_USER_PROFILE_PERSONAL_FIELDS,
          updateLastFavFilter: setLastFavFilter,
          isAdminModifyingOtherUserFilter,
          modifiedBy: user?.name || user?.email || user?.id,
        });
      }
      return { savedObj: lastSavedFilter, result };
    }

    if (pannel === TOOL_PANELS.columns) {
      const savedColumns = [...currentState];
      const updatedSavedColumns = savedColumns.map((column, index) => {
        const dataModelKey = convertToCameCase(column?.colId);
        return {
          key: dataModelKey,
          val: DATA_MODEL_TABLE[dataModelKey]?.value || "ignore",
          order: index,
          show: DATA_MODEL_TABLE[dataModelKey]?.value?.length ? !column?.hide : "ignore",
          sortStatus: listOfFieldsSortable.includes(DATA_MODEL_TABLE[dataModelKey]?.key),
        };
      });

      const showColumns = filter(updatedSavedColumns, { show: true });
      const hideColumns = filter(updatedSavedColumns, { show: false });
      const savecolumnObj = {
        displayName: chipName,
        displayDefinition: { showColumns, hideColumns },
      };

      if (type === "create") {
        savecolumnObj.userID = user?.id;
        savecolumnObj.chipName = chipName;
        result = await onCreateSelectColumn({
          id: user?.id,
          email: user?.email,
          site: user?.site,
          userDisplayList: userDisplayColumnMaster,
          unParsedData: savecolumnObj,
          client,
          query: CREATE_USER_DISPLAY_COLUMN,
          userProfileQuery: UPDATE_DIGITAL_LAB_BOOKING_USER_PROFILE_PERSONAL_FIELDS,
          updateUserDisplayColumns: setUserDisplayColumnMaster,
          updateLastDisplayColumn: setLastDisplayColumns,
        });
      } else {
        result = await onUpdateSelectColumn({
          data: JSON.stringify(savecolumnObj),
          isSaveConfigUpdated,
          updateRedux,
          id: user?.id,
          email: user?.email,
          name: user?.name,
          client,
          userProfileQuery: UPDATE_DIGITAL_LAB_BOOKING_USER_PROFILE_PERSONAL_FIELDS,
          query: UPDATE_USER_DISPLAY_COLUMN,
          userDisplayList: userDisplayColumnMaster,
          updateUserDisplayColumns: setUserDisplayColumnMaster,
          updateLastDisplayColumn: setLastDisplayColumns,
        });
      }
      return { savedObj: savecolumnObj, result };
    }
  };

  const onApplyColumns = useCallback((savedShowcolumns) => {
    let columns = null;
    if (Array.isArray(savedShowcolumns)) {
      columns = savedShowcolumns;
    } else if (savedShowcolumns?.definition?.showColumns) {
      columns = savedShowcolumns.definition.showColumns;
    } else {
      columns = convertStrToObjColumns(savedShowcolumns)?.displayDefinition?.showColumns;
    }
    setTimeout(() => onAgGridColumnApply({ gridRef, savedShowcolumns: columns }));
  }, [onAgGridColumnApply, gridRef]);

  useEffect(() => {
    if (displayPreset) {
      onApplyColumns(displayPreset);
    } else {
      onApplyColumns(defaultShowColumns);
    }
    const currentState = gridRef?.current?.columnApi?.getColumnState();
    if (onSave && currentState) {
      onSave({
        currentState,
        chipName: displayPreset ? displayPreset?.displayName : "",
        pannel: TOOL_PANELS.columns,
        updateRedux: true,
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayPreset, defaultShowColumns, gridRef]);

  const onChipDelete = async (chipToDelete, lastSavedChip, panel, userFilters) => {
    return await onDeleteSaveConfigurations({
      userID: user?.id,
      chipToDelete,
      panel,
      lastSavedChip,
      client,
      email: user?.email,
      deleteFilterQuery: DELETE_USER_FILTER,
      deleteColumnQuery: DELETE_USER_DISPLAY_COLUMN,
      userProfileQuery: UPDATE_DIGITAL_LAB_BOOKING_USER_PROFILE_PERSONAL_FIELDS,
      userFilters,
      userDisplayList: userDisplayColumnMaster,
      updateUserFilters: setUserFilters,
      updateUserDisplayColumns: setUserDisplayColumnMaster,
      updateLastFavFilter: setLastFavFilter,
      updateLastDisplayColumn: setLastDisplayColumns,
      setDisplayPreset: chipToDelete.displayName === displayPreset.label ? setDisplayPreset : null,
      setSavedFilter: chipToDelete.chipName === savedFilter ? setSavedFilter : null,
    });
  };

  const onRowSelected = useCallback(
    (params) => {
      if (params?.source === "checkboxSelected" || params?.source === "rowClicked") {
        const id = params?.data?.id;
        if (!selectedEquipment.includes(id)) {
          setSelectedEquipment((prevState) => {
            return onlyUnique([...prevState, id]);
          });
        } else {
          let uniqueList = onlyUnique(selectedEquipment);
          const index = uniqueList.indexOf(id);
          if (index > -1) {
            let temp = uniqueList;
            temp.splice(index, 1);
            setSelectedEquipment(() => {
              return temp;
            });
          }
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedEquipment]
  );

  const currentColumnsChip = useMemo(() => ({
    chipName: displayPreset?.label || displayPreset?.displayName || "",
    displayDefinition: displayPreset?.displayDefinition,
  }), [displayPreset]);

  const editBooking = async (editData) => {
    const data = cloneDeep(editData);
    const currentTimeString = moment.tz(user.timezone).utc().format();

    dispatchAction?.({
      type: "fetching",
      payload: true,
    });

    const { items } = await getAllData({
      client,
      query: GET_BOOKING_ENTRIES_BY_BOOKING_ID,
      drillData: true,
      fetchPolicy: "no-cache",
      variables: {
        bookingId: data.id,
        nextToken: null,
        filter: { active: { eq: true } },
      },
      dataPath: ["data", "bookingEntriesByBookingId"],
    });

    if (items.length > 0) {
      const keyArray = Object.keys(singleEventSkeleton);
      data["bookingEntries"] = items.map((item) => {
        let tempObj = {};
        keyArray.forEach((key) => {
          tempObj = { ...tempObj, [key]: item[key] ?? null };
        });
        tempObj = {
          ...tempObj,
          inventoryId: item.resource,
          equipment: item.equipment,
          title: item.type,
          description: item?.description,
          elnId: item?.elnId,
          project: item?.project,
          redPandaProjects : item?.redPandaProjects,
          createdBy: item?.createdBy,
          reservedForEmails: item?.reservedForEmails,
        };
        return tempObj;
      });
      if (items[0].elnId) data.elnId = items[0].elnId;
    }

    const isDuplicate = prepareBookingForDuplication(data);

    bookingDispatchAction && bookingDispatchAction({
      type: "editBookingData",
      payload: {
        isEditMode: true,
        isDuplicate,
        editBookingData: data,
        isOngoing: currentTimeString > data.dateFrom && currentTimeString < data.dateTo,
      },
    });

    const tempBookingEntries = data?.bookingEntries.map((item) => ({
      ...item,
      inventoryId: item.resource,
      isEditEventFlag: true,
      isOngoingEventFlag:
        (currentTimeString > item.end && currentTimeString > item.start) ||
        (currentTimeString > item.start && currentTimeString < item.end),
      editable: currentTimeString < item.end,
      title: item?.type,
    }));

    loadPendingReservations(tempBookingEntries);

    if (data) history.push("/");
  };


  useEffect(() => {
    if (isFilterDataReady) {
      updateCurrentFilter(savedFilter);
    }
  }, [savedFilter, isFilterDataReady, updateCurrentFilter]);

  useEffect(() => {
    if (!isFilterDataReady && user?.site && user?.id) {
      loadFilterData();
    }
  }, [isFilterDataReady, user?.site, user?.id, loadFilterData]);

  useEffect(() => {
    if (gridApi) {
      gridRef.current.api.setQuickFilter(searchQuery);
    }
  }, [searchQuery, gridRef, gridApi]);

  const dateFromFormatter = (params) =>
    moment(params?.data?.dateFrom).tz(user.timezone).format("DD-MMM-YYYY h:mm A");

  const dateToFormatter = (params) =>
    moment(params?.data?.dateTo).tz(user.timezone).format("DD-MMM-YYYY h:mm A");

  return {
    currentFilterChip,
    onApplyColumns,
    currentColumnsChip,
    onRowSelected,
    onChipDelete,
    dateFromFormatter,
    dateToFormatter,
    onSave,
    editBooking,
    icons: GridIcons,
  };
};

